:host {
  display: block;
}

.add-role-row{
  display: flex;
  gap: 1em;
  align-items: center;
  flex-wrap: wrap;
  label{
    margin-right:0.5em;
  }
}
.search-user{
  display: flex;
  gap: 1em;
  margin-top: 1em;
  .search-control{
    position: relative;
    dnn-collapsible{
      position: absolute;
      left: 0;
      top: calc(100% - 2px);
      width: 100%;
      box-shadow: 0px 4px 4px;
      .dropdown{
        background-color: white;
        border: 1px solid lightgray;
        display: flex;
        flex-direction: column;
        button{
          background-color: transparent;
          border: none;
          border-bottom: 1px solid lightgray;
          padding: 0.25em;
          margin: 0;
          text-align: left;
        }
      }
    }
  }
}
table{
  border: 1px solid lightgray;
  border-collapse: collapse;
  margin-top: 1em;
  thead{
    text-align: center;
    tr{
      border-bottom: 1px solid lightgray;
    }
    th{
      background-color: lightgray;
      padding: 0.25em 0.5em;
      &:first-child{
        border-right: 1px solid lightgray;
      }
    }
  }
  tbody{
    tr{
      border-bottom: 1px dotted lightgray;
      th{
        text-align: left;
        border-right: 1px solid lightgray;
        padding: 0 0.5em;
      }
      td{
        text-align: center;
        label{
          .hidden{
            display: none;
          }
        }
        button{
          background-color: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          margin-right: 1em;
        }
      }
    }
  }
}